import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleOAuthCallback, getOAuthCallbackParams } from '@/lib/authService';
import { useAuth } from '@/contexts/AuthContext';
import { getPostLoginReturnUrl } from '@/components/auth/ProtectedRoute';

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const { refreshAuthState } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      const params = getOAuthCallbackParams();
      if (!params) {
        setError('Missing OAuth parameters');
        return;
      }
      const result = await handleOAuthCallback(params.code, params.state);
      if (!result.success) {
        setError(result.error);
        return;
      }
      await refreshAuthState();
      const returnUrl = getPostLoginReturnUrl() || '/applications';
      navigate(returnUrl, { replace: true });
    })();
  }, [navigate, refreshAuthState]);

  if (error) {
    return (
      <div
        style={{
          display: 'flex',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--space-7)',
          background: 'var(--bg)',
        }}
      >
        <div className="alert" data-tone="danger" style={{ maxWidth: 480 }}>
          <svg
            className="alert-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
          <div className="alert-body">
            <div className="alert-title">Sign-in failed</div>
            <p style={{ margin: '0 0 var(--space-4)' }}>{error}</p>
            <a className="btn" data-variant="secondary" data-size="sm" href="/applications">
              Try again
            </a>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--fg-muted)',
        background: 'var(--bg)',
      }}
    >
      Completing sign-in...
    </div>
  );
}
